import { IProductOfferingPrice } from 'app/shared/model/product-offering-price.model';
import { TariffType } from 'app/shared/model/enumerations/tariff-type.model';
import { ProductType } from 'app/shared/model/enumerations/product-type.model';

export interface ITariff {
  id?: number;
  type?: keyof typeof TariffType | null;
  productType?: keyof typeof ProductType | null;
  isFixedTariff?: boolean | null;
  productOfferingPrices?: IProductOfferingPrice[] | null;
}

export const defaultValue: Readonly<ITariff> = {
  isFixedTariff: false,
};
